/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of  InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {  InventoryPurchaseDetailsApi } from './../../api/transaction/purchasedetails.api';
import {  InventoryPurchaseDetailsData,  InventoryPurchaseDetails } from './../../interface/transaction/purchasedetails';

@Injectable()
export class  InventoryPurchaseDetailsService extends  InventoryPurchaseDetailsData {

  constructor(private api:  InventoryPurchaseDetailsApi) {
    super();
  }



  list(url: string): Observable<InventoryPurchaseDetails[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<InventoryPurchaseDetails>{
      return this.api.getById(url);
  }

  create(url: string, data:InventoryPurchaseDetails): Observable<InventoryPurchaseDetails> {
    return this.api.add(url,data);
  }

  update(url: string, data:InventoryPurchaseDetails): Observable<InventoryPurchaseDetails> {
    console.log('url', url);
    console.log('data', data);
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
